









































import { Component, Vue } from 'vue-property-decorator'
import Samples from '@/components/SamplesComponent.vue'
@Component({
  components: {
    Samples
  },
})
export default class Home extends Vue {
  public Badges = [
    'https://img.shields.io/codecov/c/github/ealenn/LarbinBot?style=for-the-badge&logo=codecov',
    'https://img.shields.io/github/stars/Ealenn/LarbinBot?style=for-the-badge&logo=github',
    'https://img.shields.io/github/issues/Ealenn/LarbinBot?style=for-the-badge&logo=github',
    'https://img.shields.io/github/v/release/ealenn/LarbinBot?style=for-the-badge',
    'https://img.shields.io/docker/pulls/ealen/larbinbot?style=for-the-badge'
  ];
}
